// caso de uso con evento - application layer

import { PeriodoInventarioRepository } from "../infrastructure/supabase/PeriodoInventarioRepository.js";
import { MovimientoInventario } from "../domain/agreggates/MovimientoInventario.aggregate.js";
import { MovimientoInventarioRepository } from "../infrastructure/supabase/movimientoInventarioRepository.repository.js";
import { domainEventDispatcher } from "../domain/events/DomainEventDispatcher.js";

export async function registrarSalidaInventarioUseCase(params) {

  const trace = {
    etapa: "inicio",
    producto: null,
    periodo: null,
    movimiento: null
  };

  try {

    console.log("[Inventario][UseCase] ▶ Inicio registrarSalidaInventarioUseCase", params);

    const {
      idProducto,
      cantidad,
      idReferencia,
      origen = "Venta",
      tipoMovimiento = "salida",
      createdBy = 3,
    } = params;

    trace.producto = idProducto;

    if (!idProducto) throw new Error("ID de producto requerido");
    if (!cantidad || cantidad <= 0) throw new Error("Cantidad debe ser mayor a 0");
    if (!idReferencia) throw new Error("ID de referencia requerido");

    // --------------------------------
    // 1️ Obtener periodo activo
    // --------------------------------

    trace.etapa = "obtenerPeriodo";

    console.log("[Inventario][UseCase] Buscando periodo abierto...");

    const periodoRepo = new PeriodoInventarioRepository();
    const periodo = await periodoRepo.obtenerPeriodoAbierto();

    if (!periodo) {
      throw new Error("No existe periodo abierto");
    }

    const periodoId = periodo.id;
    trace.periodo = periodoId;

    console.log("[Inventario][UseCase] ✔ Periodo activo:", periodoId);

    // --------------------------------
    // 2️ Crear aggregate
    // --------------------------------

    trace.etapa = "crearAggregate";

    const movimientoAggregate = new MovimientoInventario({
      periodoId,
      createdBy,
    });

    console.log("[Inventario][UseCase] ✔ Aggregate creado");

    // --------------------------------
    // 3️ Crear movimiento
    // --------------------------------

    trace.etapa = "crearMovimiento";

    const movimiento = movimientoAggregate.agregarVenta({
      idProducto,
      cantidad,
      idReferencia,
      origen,
      tipoMovimiento,
    });

    trace.movimiento = movimiento;

    console.log("[Inventario][UseCase] ✔ Movimiento creado:", movimiento);

    // --------------------------------
    // 4️ Guardar movimiento
    // --------------------------------

    trace.etapa = "guardarMovimiento";

    const movimientoRepository = new MovimientoInventarioRepository();

    const guardado =
      await movimientoRepository.insertarMovimientoInventario(movimiento);

    console.log("[Inventario][Repository] ✔ Movimiento guardado:", guardado);

    // --------------------------------
    // 5️ Crear evento
    // --------------------------------

    trace.etapa = "crearEvento";

    const evento = movimientoAggregate.crearEvento(guardado);

    console.log("[Inventario][DomainEvent] ✔ Evento creado:", evento);

    // --------------------------------
    // 6️ Despachar evento
    // --------------------------------

    trace.etapa = "despacharEvento";

    await domainEventDispatcher.dispatch(evento);

    console.log("[Inventario][Dispatcher] ✔ Evento despachado");

    // --------------------------------
    // 7️ Limpiar eventos
    // --------------------------------

    trace.etapa = "limpiarEventos";

    movimientoAggregate.limpiarEventos();

    console.log("[Inventario][Aggregate] ✔ Eventos limpiados");

    console.log("[Inventario][UseCase] ✔ FIN registrarSalidaInventarioUseCase");

    return guardado;

  } catch (error) {

    console.error(
      "[Inventario][UseCase] X Error en etapa:",
      trace.etapa,
      {
        producto: trace.producto,
        periodo: trace.periodo,
        movimiento: trace.movimiento,
        error: error.message
      }
    );

    throw error;
  }
}